import { Controller, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Form, Button, Spinner, Row, Col } from "react-bootstrap";
import axios from "axios";
import API_URL from "../../../ApiUrl";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ConsultationForm() {
    const {
        register,
        control,
        handleSubmit,
        reset,
        formState: { errors, isValid }
    } = useForm({
        mode: "onChange"
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [consultants, setConsultants] = useState([]);
    const [loadingConsultants, setLoadingConsultants] = useState(true);

    useEffect(() => {
        const fetchConsultants = async () => {
            try {
                const res = await axios.get(`${API_URL.superStudent2}/master/consultant/list-priotas`, {
                    headers: {
                        Authorization: `Bearer ${process.env.API_KEY}`
                    }
                });
                setConsultants(res.data?.data || []);
            } catch (error) {
                console.error("Gagal fetch konsultan", error);
            } finally {
                setLoadingConsultants(false);
            }
        };

        fetchConsultants();
    }, []);

    const onSubmit = async (data) => {
        setIsSubmitting(true);

        try {
            const payload = {
                code_konsultan: data.code_konsultan,
                client_name: data.client_name,
                client_email: data.client_email,
                client_phone: data.client_phone,
                booking_date: `${data.date} ${data.time}`
            };

            await axios.post(`${API_URL.superStudent}/api/v1/meeting-booking`, payload);
            reset();
            Swal.fire({
                icon: "success",
                title: "Booking Berhasil!",
                text: "Data Anda berhasil dikirim dan sedang menunggu konfirmasi.",
                confirmButtonText: "OK"
            });
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Booking Gagal!",
                text: "Data Anda gagal dikirim. Silahkan coba kembali.",
                confirmButtonText: "OK"
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)} className="p-4 rounded border form-consultation">
            <Row className="flex-column flex-nowrap">
                <Col>
                    <Form.Group className="mb-2">
                        <Form.Label>Nama Lengkap</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Masukkan nama lengkap"
                            isInvalid={!!errors.client_name}
                            {...register("client_name", {
                                required: "Nama wajib diisi"
                            })}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.client_name?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-2">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="contoh@email.com"
                            isInvalid={!!errors.client_email}
                            {...register("client_email", {
                                required: "Email wajib diisi",
                                pattern: {
                                    value: /^\S+@\S+\.\S+$/,
                                    message: "Format email tidak valid"
                                }
                            })}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.client_email?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-2">
                        <Form.Label>Pilih Konsultan</Form.Label>
                        <Form.Select
                            disabled={loadingConsultants}
                            isInvalid={!!errors.code_konsultan}
                            {...register("code_konsultan", {
                                required: "Konsultan wajib dipilih"
                            })}
                        >
                            <option value="">
                                {loadingConsultants
                                    ? "Loading konsultan..."
                                    : "-- Daftar konsultan --"}
                            </option>

                            {consultants.map((c) => (
                                <option key={c.id} value={c.code}>
                                    {c.name} - {c.area}
                                </option>
                            ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                            {errors.code_konsultan?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-2">
                        <Form.Label>No WhatsApp</Form.Label>
                        <Form.Control
                            type="tel"
                            placeholder="08xxxxxxxxxx"
                            isInvalid={!!errors.client_phone}
                            {...register("client_phone", {
                                required: "No WhatsApp wajib diisi",
                                minLength: {
                                    value: 10,
                                    message: "No WhatsApp minimal 10 digit"
                                }
                            })}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.client_phone?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-2 d-flex flex-column">
                        <Form.Label>Tanggal Konsultasi</Form.Label>
                        <Controller
                            name="date"
                            control={control}
                            rules={{ required: "Tanggal wajib diisi" }}
                            render={({ field }) => (
                                <DatePicker
                                    placeholderText="Pilih tanggal"
                                    selected={field.value}
                                    onChange={field.onChange}
                                    filterDate={(date) => {
                                        const day = date.getDay();
                                        return day !== 0 && day !== 6;
                                    }}
                                    className={`form-control ${errors.date ? "is-invalid" : ""}`}
                                    dateFormat="yyyy-MM-dd"
                                />
                            )}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.date?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label>Jam Konsultasi</Form.Label>
                        <Form.Control
                            type="time"
                            isInvalid={!!errors.time}
                            {...register("time", {
                                required: "Jam wajib diisi"
                            })}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.time?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <Button
                type="submit"
                variant="danger"
                disabled={!isValid || isSubmitting}
                className="w-100"
            >
                {isSubmitting ? (
                    <>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            className="me-2"
                        />
                        Mengirim...
                    </>
                ) : (
                    "Jadwalkan Konsultasi"
                )}
            </Button>
        </Form>
    );
}